import {FC, useEffect, useMemo, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {
  activateClickFunnelsClassicIntegration,
  deactivateClickFunnelsClassicIntegration,
  fetchActiveIntegrationApp,
  getActivateIntegrationByUser,
  getIntegrationRefetchDataStatus,
  resetSelectedIntegrationData,
} from '../IntegrationSlice/IntegrationSlice'
import {Form, Button, Accordion, Card} from 'react-bootstrap'
import {isLoading} from '../../../../Redux/FrontEnd/Loading/LoadingSlice'
import DeleteConfirmationPopup from '../../../../Components/DeleteConfirmationPopup'
import {ExternalProvider} from '../IntegrationSlice/Types'
import {toAbsoluteUrl} from '../../../../../_metronic/helpers'

interface ClickFunnelsClassicProps {
  selectedExternalProvider: ExternalProvider
  userData: any
}

const ClickFunnelsClassic: FC<ClickFunnelsClassicProps> = ({
  selectedExternalProvider,
  userData,
}) => {
  let userId = ''
  if (userData && userData.user) {
    if (userData.user._id !== userData.user.ownerId && !userData.user.subClientAccountId) {
      userId = userData.user.ownerId
    } else {
      userId = userData.user._id
    }
  }

  const selectedActiveIntegration = useSelector(
    getActivateIntegrationByUser(userId, selectedExternalProvider._id)
  )

  const refetch = useSelector(getIntegrationRefetchDataStatus)
  const globalLoading = useSelector(isLoading)

  const dispatch = useDispatch()

  // load data when first load
  useEffect(() => {
    dispatch(resetSelectedIntegrationData)
    dispatch(fetchActiveIntegrationApp())
  }, [])

  useEffect(() => {
    if (refetch) {
      // console.debug(`[integrationPageDetail] refetch for call recall data`)
      dispatch(fetchActiveIntegrationApp())
    }
  }, [refetch])

  // handle delete
  const [isOpenDeleteConfirmation, setIsOpenDeleteConfirmation] = useState(false)
  const [isDeleteConfirm, setIsDeleteConfirm] = useState(false)

  const onClickDeactivateHandler = () => {
    setIsOpenDeleteConfirmation(true)
  }

  const onClickActivateHandler = () => {
    dispatch(activateClickFunnelsClassicIntegration())
  }

  const confirmation = useMemo(
    () => (
      <DeleteConfirmationPopup
        show={isOpenDeleteConfirmation}
        handleClose={() => setIsOpenDeleteConfirmation(false)}
        Message={'Are you sure, you want to deactivate integration ?'}
        confirm={() => setIsDeleteConfirm(true)}
        confirmBtnTitle='Yes, deactivate'
      />
    ),
    [isOpenDeleteConfirmation]
  )

  useEffect(() => {
    if (isDeleteConfirm == true) {
      dispatch(deactivateClickFunnelsClassicIntegration())
      setIsDeleteConfirm(false)
      setIsOpenDeleteConfirmation(false)
    }
  }, [isDeleteConfirm])

  return (
    <div className='card p-7 pb-lg-4 p-lg-10'>
      {confirmation}
      <h1>Detail Integration</h1>
      <div className='row'>
        <div className='card-body pt-9 pb-0'>
          <div className='d-flex flex-wrap flex-sm-nowrap mb-3'>
            <div className='me-7 mb-4'>
              <div className='symbol symbol-100px symbol-lg-160px symbol-fixed position-relative'>
                {selectedExternalProvider?.image == '' || selectedExternalProvider == undefined ? (
                  <span
                    className='squere1'
                    style={{
                      width: '100px',
                      height: '100px',
                    }}
                  >{`${
                    selectedExternalProvider?.name !== undefined &&
                    selectedExternalProvider?.name !== ''
                      ? selectedExternalProvider?.name.split('')?.[0]?.toUpperCase() ?? 'C'
                      : 'EP'
                  }`}</span>
                ) : (
                  <img src={selectedExternalProvider.image} alt='Cellcast' />
                )}
                <div
                  className={`position-absolute translate-middle bottom-0 start-100 mb-6 rounded-circle border border-4 border-white h-20px w-20px ${
                    selectedActiveIntegration ? ' bg-success ' : 'bg-danger'
                  }`}
                ></div>
              </div>
            </div>
            <div className='flex-grow-1'>
              <span className='text-gray-800 fs-2 fw-bolder me-1 mb-10'>
                {selectedExternalProvider?.name ?? 'Undefined'}
              </span>
              {selectedActiveIntegration ? (
                <div className='mt-5'>
                  <Form.Group className='mb-10'>
                    <Form.Label>Cellcast Api Key Label</Form.Label>
                    <Form.Control
                      type='text'
                      disabled
                      value={selectedActiveIntegration?.internalApiKeyName}
                    />
                  </Form.Group>
                  <Form.Group className='mb-10'>
                    <Form.Label>Cellcast Api Key </Form.Label>
                    <Form.Control
                      as='textarea'
                      rows={3}
                      disabled
                      value={selectedActiveIntegration?.internalApiToken}
                    />
                  </Form.Group>

                  <Accordion className='mb-10'>
                    <Accordion.Item eventKey='0'>
                      <Accordion.Header>Integration Step</Accordion.Header>
                      <Accordion.Body>
                        <div className='row mb-10'>
                          <div className='mb-5' style={{fontSize: 14}}>
                            1. Click Funnels <i className='bi bi-arrow-right-short'></i> Funnels
                          </div>
                          <img
                            src={toAbsoluteUrl('/media/click-funnels/step-1.png')}
                            width={'75%'}
                            alt='nav-click'
                          />
                        </div>
                        <div className='row mb-10'>
                          <div className='mb-5' style={{fontSize: 14}}>
                            2. Select funnels that you want to integrate
                          </div>
                          <img
                            src={toAbsoluteUrl('/media/click-funnels/step-2.png')}
                            width={'75%'}
                            alt='nav-click'
                          />
                        </div>
                        <div className='row mb-10'>
                          <div className='mb-5' style={{fontSize: 14}}>
                            3. Go to <b>settings</b> page
                          </div>
                          <img
                            src={toAbsoluteUrl('/media/click-funnels/step-3.png')}
                            width={'75%'}
                            alt='nav-click'
                          />
                        </div>
                        <div className='row mb-10'>
                          <div className='mb-5' style={{fontSize: 14}}>
                            4. Find <b>manage your funnel webhooks</b> in webhook section
                          </div>
                          <img
                            src={toAbsoluteUrl('/media/click-funnels/step-4.png')}
                            width={'75%'}
                            alt='nav-click'
                          />
                        </div>
                        <div className='row mb-10'>
                          <div className='mb-5' style={{fontSize: 14}}>
                            5. Create New Webhook
                          </div>
                          <img
                            src={toAbsoluteUrl('/media/click-funnels/step-5.png')}
                            width={'75%'}
                            alt='nav-click'
                          />
                        </div>
                        <div className='row mb-10'>
                          <div className='mb-5' style={{fontSize: 14}}>
                            6. Input webhook data
                          </div>
                          <img
                            src={toAbsoluteUrl('/media/click-funnels/step-6.png')}
                            width={'75%'}
                            alt='nav-click'
                          />
                          <div className='mt-5'>
                            insert this url
                            <pre>
                              {`https://api.cellcast.com/api/v1/webhook/clickfunnels/classic/{YourApiKey}/{FunnelName}`}
                            </pre>
                            <b>Api Key</b> is your cellcast api key from information above
                            <br />
                            <b>Funnel Name</b> is the name of the funnel that you want to send data
                            from, this will appear as a "Tag" on the contact in your cellcast
                            portal. This can not contain space, please replace any space with `-` or
                            `_ '
                            <br />
                            for event you can choose <b>all event</b> or created contact event
                            <br />
                            <br />
                            <b>Note</b>: only customer that complete your forms will auto sync. All
                            manually added contacts or customers will not auto sync to the cellcast
                            platform.
                          </div>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey='1'>
                      <Accordion.Header>Video Tutorial</Accordion.Header>
                      <Accordion.Body>
                        <iframe
                          src='https://www.loom.com/embed/fc2a3eae20744b4bbb245156d3a6d382'
                          frameBorder='0'
                          allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
                          allowFullScreen
                          style={{width: '100%', height: '500px'}}
                          title='Loom video'
                        ></iframe>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                  <Button
                    variant='danger'
                    type='submit'
                    disabled={globalLoading}
                    onClick={() => onClickDeactivateHandler()}
                  >
                    {globalLoading ? (
                      <span className='spinner-border spinner-border-xl align-middle ms-2'></span>
                    ) : (
                      'Deactivate'
                    )}
                  </Button>
                </div>
              ) : (
                <div className='mt-20'>
                  <Button
                    variant='primary'
                    type='button'
                    disabled={globalLoading}
                    onClick={() => onClickActivateHandler()}
                  >
                    {globalLoading ? (
                      <span className='spinner-border spinner-border-xl align-middle ms-2'></span>
                    ) : (
                      'Activate'
                    )}
                  </Button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export {ClickFunnelsClassic}
